'use strict';

var _ = require('lodash');
var RsqlQueryProperty = function RsqlQueryProperty(name) {
  this.name = name;
};
RsqlQueryProperty.prototype.toString = function () {
  return this.name;
};
var RsqlQueryOperator = function RsqlQueryOperator(operator) {
  this.operator = operator;
};
RsqlQueryOperator.prototype.toString = function () {
  return this.operator;
};
var RsqlQueryCondition = function RsqlQueryCondition(operator, value) {
  if (!(operator instanceof RsqlQueryOperator)) {
    throw new Error('Invalid operator');
  }
  this.operator = operator;
  this.value = value;
};
var BetweenValue = function BetweenValue(from, to) {
  this.from = from;
  this.to = to;
};
BetweenValue.prototype.toString = function () {
  if (_.isNumber(this.from) && _.isNumber(this.to)) {
    return '(' + this.from + ' AND ' + this.to + ')';
  } else {
    return '(\'' + this.from + '\' AND \'' + this.to + '\')';
  }
};
function valueToString(value) {
  if (_.isString(value)) {
    if (/^FlowType/.test(value) || /\.urd\(/.test(value) || /\.daysOffsets\(/.test(value)) {
      return value;
    }
    return /^'[^']*'$/.test(value) ? value : '\'' + value + '\'';
  } else if (_.isArray(value)) {
    return '(' + _.map(value, valueToString).join(',') + ')';
  } else {
    return value;
  }
}
RsqlQueryCondition.prototype.toString = function () {
  return this.operator + valueToString(this.value);
};
var RsqlQueryBuilder = function RsqlQueryBuilder(parent) {
  this.queue = [];
  this.parent = parent;
};
RsqlQueryBuilder.prototype.withAndOperator = function (operator) {
  this.andOperator = operator || ';';
  return this;
};
RsqlQueryBuilder.prototype.withOrOperator = function (operator) {
  this.orOperator = operator || ',';
  return this;
};
function reducePartials(values, separator) {
  return values.filter(function (value) {
    return value instanceof RsqlQueryBuilder;
  }).reduceRight(function (previousValue, value, index) {
    var partial = value.buildPartial();
    if (index > 0) {
      partial.unshift(separator);
    }
    previousValue = partial.concat(previousValue);
    return previousValue;
  }, []);
}
RsqlQueryBuilder.prototype.is = function (property) {
  var builder = new RsqlQueryBuilder(this).withAndOperator(this.andOperator).withOrOperator(this.orOperator);
  builder.queue.push(new RsqlQueryProperty(property));
  return builder;
};
RsqlQueryBuilder.prototype.isEmpty = function () {
  return this.queue.length < 1;
};
RsqlQueryBuilder.prototype.equalTo = function (value) {
  return this.condition('==', value);
};
RsqlQueryBuilder.prototype.dtdEqualTo = function (value) {
  return this.condition('=dtdEq=', value);
};
RsqlQueryBuilder.prototype.dtdNotEqualTo = function (value) {
  return this.condition('=dtdNe=', value);
};
RsqlQueryBuilder.prototype.dtdGt = function (value) {
  return this.condition('=dtdGt=', value);
};
RsqlQueryBuilder.prototype.dtdGe = function (value) {
  return this.condition('=dtdGe=', value);
};
RsqlQueryBuilder.prototype.dtdLe = function (value) {
  return this.condition('=dtdLe=', value);
};
RsqlQueryBuilder.prototype.dtdLt = function (value) {
  return this.condition('=dtdLt=', value);
};
function getTargetValues(args) {
  var values = Array.isArray(args[0]) ? args[0] : Array.prototype.slice.call(args);
  return values.filter(function (value) {
    return value !== undefined && value !== null;
  });
}
RsqlQueryBuilder.prototype["in"] = function () {
  return this.condition('=in=', getTargetValues(arguments));
};
RsqlQueryBuilder.prototype.out = function () {
  return this.condition('=out=', getTargetValues(arguments));
};
RsqlQueryBuilder.prototype.inRange = function (from, to) {
  var previousPropertyIndex = _.findLastIndex(this.queue, function (element) {
    return element instanceof RsqlQueryProperty;
  });
  var property = previousPropertyIndex >= 0 ? this.queue[previousPropertyIndex] : undefined;
  if (property) {
    return this.ge(from).and().is(property.name).le(to);
  }
  return this;
};
RsqlQueryBuilder.prototype.notInRange = function (from, to) {
  var previousPropertyIndex = _.findLastIndex(this.queue, function (element) {
    return element instanceof RsqlQueryProperty;
  });
  var property = previousPropertyIndex >= 0 ? this.queue[previousPropertyIndex] : undefined;
  if (property) {
    return this.gt(to).or().is(property.name).lt(from);
  }
  return this;
};
RsqlQueryBuilder.prototype.between = function (from, to) {
  return this.inRange(from, to).endGroup();
};
//add some of these methods but for DTD this time!
RsqlQueryBuilder.prototype.notBetween = function (from, to) {
  return this.notInRange(from, to).endGroup();
};
RsqlQueryBuilder.prototype.lt = function (value) {
  return this.condition('=lt=', value);
};
RsqlQueryBuilder.prototype.le = function (value) {
  return this.condition('=le=', value);
};
RsqlQueryBuilder.prototype.gt = function (value) {
  return this.condition('=gt=', value);
};
RsqlQueryBuilder.prototype.ge = function (value) {
  return this.condition('=ge=', value);
};
RsqlQueryBuilder.prototype.exists = function (value) {
  return this.condition('=exists=', value);
};
RsqlQueryBuilder.prototype.notEqualTo = function (value) {
  return this.condition('!=', value);
};
RsqlQueryBuilder.prototype.contains = function (value) {
  return this.condition('=contains=', value);
};
RsqlQueryBuilder.prototype.notContains = function (value) {
  return this.condition('=notContains=', value);
};
RsqlQueryBuilder.prototype.sdeq = function (value) {
  return this.condition('=sdeq=', value);
};
RsqlQueryBuilder.prototype.sdne = function (value) {
  return this.condition('=sdne=', value);
};
RsqlQueryBuilder.prototype.sdin = function () {
  return this.condition('=sdin=', getTargetValues(arguments));
};
RsqlQueryBuilder.prototype.sdout = function () {
  return this.condition('=sdout=', getTargetValues(arguments));
};
RsqlQueryBuilder.prototype.condition = function (operator, value) {
  this.queue.push(new RsqlQueryCondition(new RsqlQueryOperator(operator), value));
  return this;
};
RsqlQueryBuilder.prototype.and = function () {
  if (this.queue.length > 0) {
    this.queue.push(new RsqlQueryOperator(this.andOperator));
  }
  return this;
};
RsqlQueryBuilder.prototype.or = function () {
  if (this.queue.length > 0) {
    this.queue.push(new RsqlQueryOperator(this.orOperator));
  }
  return this;
};
RsqlQueryBuilder.prototype.orGroup = function () {
  var values = Array.prototype.slice.call(arguments);
  var partials = reducePartials(values, new RsqlQueryOperator(this.orOperator));
  this.queue.push(new RsqlQueryOperator('('));
  this.queue = this.queue.concat(partials);
  this.queue.push(new RsqlQueryOperator(')'));
  return this;
};
RsqlQueryBuilder.prototype.orGroupSimple = function () {
  var values = Array.prototype.slice.call(arguments);
  var partials = reducePartials(values, new RsqlQueryOperator(this.orOperator));
  this.queue = this.queue.concat(partials);
  return this;
};
RsqlQueryBuilder.prototype.andGroup = function () {
  var values = Array.prototype.slice.call(arguments);
  var partials = reducePartials(values, new RsqlQueryOperator(this.andOperator));
  this.queue.push(new RsqlQueryOperator('('));
  this.queue = this.queue.concat(partials);
  this.queue.push(new RsqlQueryOperator(')'));
  return this;
};
RsqlQueryBuilder.prototype.andGroupSimple = function () {
  var values = Array.prototype.slice.call(arguments);
  var partials = reducePartials(values, new RsqlQueryOperator(this.andOperator));
  this.queue = this.queue.concat(partials);
  return this;
};
RsqlQueryBuilder.prototype.buildPartial = function () {
  if (this.parent) {
    return this.parent.buildPartial().concat(this.queue);
  } else {
    return this.queue;
  }
};
RsqlQueryBuilder.prototype.query = function () {
  return this.buildPartial().join('');
};
RsqlQueryBuilder.prototype.startGroup = function () {
  this.queue.push(new RsqlQueryOperator('('));
  return this;
};
RsqlQueryBuilder.prototype.endGroup = function () {
  this.queue.push(new RsqlQueryOperator(')'));
  return this;
};
RsqlQueryBuilder.prototype.toString = RsqlQueryBuilder.prototype.query;
var RsqlQuery = function RsqlQuery() {};
RsqlQuery.prototype.withAndOperator = function (operator) {
  this.andOperator = operator || ';';
  return this;
};
RsqlQuery.prototype.withOrOperator = function (operator) {
  this.orOperator = operator || ',';
  return this;
};
RsqlQuery.prototype.is = function (property, isBetween) {
  this.rsqlQueryBuilder = new RsqlQueryBuilder().withOrOperator(this.orOperator).withAndOperator(this.andOperator);
  if (isBetween) {
    this.rsqlQueryBuilder = this.rsqlQueryBuilder.startGroup();
  }
  this.rsqlQueryBuilder = this.rsqlQueryBuilder.is(property);
  return this.rsqlQueryBuilder;
};
RsqlQuery.prototype.and = function () {
  var values = Array.prototype.slice.call(arguments);
  this.rsqlQueryBuilder = new RsqlQueryBuilder().withOrOperator(this.orOperator).withAndOperator(this.andOperator).and(values);
  return this.rsqlQueryBuilder;
};
RsqlQuery.prototype.or = function () {
  var values = Array.prototype.slice.call(arguments);
  this.rsqlQueryBuilder = new RsqlQueryBuilder().withOrOperator(this.orOperator).withAndOperator(this.andOperator).or(values);
  return this.rsqlQueryBuilder;
};
RsqlQuery.prototype.isEmpty = function () {
  return !_.isObject(this.rsqlQueryBuilder) || _.isObject(this.rsqlQueryBuilder) && this.rsqlQueryBuilder.isEmpty();
};
var RsqlQueryFactory = function RsqlQueryFactory() {
  return RsqlQuery;
};
RsqlQueryFactory.$inject = [];
module.exports = RsqlQueryFactory;